import React from 'react';
import { PetInterface } from 'types/pet';
import PageLoader from '../loaders/PageLoader';
import { isNotChewyMobileApp } from '../../util/helpers';
import './puppy-guide-layout.scss';
import HeaderPuppyGuide from './Header';
import Content from './Content';
import { PuppyGuideProvider } from './PuppyGuideContext';
import StickyHeader from './StickyHeader';
import BreadCrumbsPuppyGuide from './BreadCrumbsPuppyGuide';

const LayoutPuppyGuide = ({ isLoading, data }: { isLoading: boolean; data?: PetInterface }) =>
  !isLoading ? (
    <PuppyGuideProvider>
      {isNotChewyMobileApp() && <BreadCrumbsPuppyGuide petProfile={data} />}
      <HeaderPuppyGuide />
      <StickyHeader />
      <Content petProfile={data} />
    </PuppyGuideProvider>
  ) : (
    <PageLoader />
  );

export default LayoutPuppyGuide;
